export var PLAN_SCOPES = [
    'pro',
    'premium'
];
export var PLAN_VERSIONS = [
    'initial',
    'Q3-2024'
];
